module.exports = __webpack_public_path__ + "img/lia_03.eb6e02e4.png";